import { Dispatch, SetStateAction, useCallback, useEffect } from 'react';

interface ApprovalType {
  url?: string;
  onSetStep: Dispatch<SetStateAction<string>>;
}

export const Approval = (props: ApprovalType) => {
  const handleMessage = useCallback(
    (e: MessageEvent) => {
      if (e.data.function !== 'iframeParent') return;
      const ok = e.data.status === 'AUTHORIZED';
      const step = ok ? 'success' : 'error';
      props.onSetStep(step);
    },
    [props.onSetStep],
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);

  return (
    <div className='flex flex-col items-center gap-[56px] opacity-100 transition-opacity duration-300'>
      {props.url ? (
        <div className='h-[600px] w-[600px]'>
          <iframe className='h-full w-full border-none' title='approval' src={props.url} />
        </div>
      ) : null}
    </div>
  );
};
